import { observable, observe, toJS } from "mobx";
import { appConfig } from "./appConfig";

export class ObservableService {
  static debug = false;

  static persistentObservableBox(name, getValue, durationSeconds = -1) {
    const value = this.getValue(name, getValue, durationSeconds);
    const obs = observable.box(value);
    obs.observe((change) => {
      this.log(`[PersistentObservable - "-= Dimensionamento de Redes - Site =-"] Observable changed`);
      this.persistentObservableBox(name, durationSeconds, change.newValue);
    });

    return obs;
  }

  static persistentObservable(name, getValue, durationSeconds = -1) {
    const value = this.getValue(name, getValue, durationSeconds);
    const obs = observable(value);
    observe(obs, (change) => {
      this.log(`[PersistentObservable - "-= Dimensionamento de Redes - Site =-"] Observable changed.`);
      this.store(name, durationSeconds, change.object);
      this.persistentObservable(name, durationSeconds, change.object);
    });

    return obs;
  }

  static getValue(name, getValue, durationSeconds = -1) {
    let value = undefined;

    const jsonFromStorage = localStorage.getItem(name);
    if (jsonFromStorage !== null) {
      const valueFromStorage = JSON.parse(
        decodeURIComponent(window.atob(jsonFromStorage))
      );
      this.log(
        `[PersistentObservable - "-= Dimensionamento de Redes - Site =-"] Found value stored:`,
        valueFromStorage
      );

      const now = Date.now();
      this.log(
        `[PersistentObservable - "-= Dimensionamento de Redes - Site =-"] Current time is`,
        Date.now()
      );
      if (
        now < valueFromStorage.expirationDate &&
        valueFromStorage.schemaVersion === appConfig.SCHEMA_VERSION
      ) {
        this.log(
          `[PersistentObservable - "-= Dimensionamento de Redes - Site =-"] Using value stored:`,
          valueFromStorage
        );
        value = valueFromStorage.value;
      } else {
        if (valueFromStorage.schemaVersion !== appConfig.SCHEMA_VERSION) {
          this.log(
            `[PersistentObservable - "-= Dimensionamento de Redes - Site =-"] Value is from old schema. Ignoring.`
          );
        } else {
          if (name === "SessionStore") {
            this.log(
              `[PersistentObservable - "-= Dimensionamento de Redes - Site =-"] Value is expired. Clearing.`
            );
            localStorage.removeItem(name);
          }
          this.log(`[PersistentObservable - "-= Dimensionamento de Redes - Site =-"] Value is expired.`);
        }
      }
    }

    if (value === undefined) {
      value = getValue();
      this.store(name, durationSeconds, value);
    }

    return value;
  }

  static store(name, duration, value) {
    const toStore = {
      value: toJS(value),
      expirationDate:
        duration !== -1
          ? Date.now() + duration * 1000
          : new Date(3000, 0, 1, 0, 0, 0, 0).getTime(),
      schemaVersion: appConfig.SCHEMA_VERSION,
    };
    this.log(`[PersistentObservable - "-= Dimensionamento de Redes - Site =-"] Storing new value:`, toStore);
    localStorage.setItem(
      name,
      window.btoa(encodeURIComponent(JSON.stringify(toStore)))
    );
  }

  static log(...data) {
    if (this.debug) {
      console.log(...data);
    }
  }
}
